import { render } from "./TermsConditionsView.vue?vue&type=template&id=6fb0f1e7&scoped=true&ts=true"
import script from "./TermsConditionsView.vue?vue&type=script&lang=ts"
export * from "./TermsConditionsView.vue?vue&type=script&lang=ts"

import "./TermsConditionsView.scss?vue&type=style&index=0&id=6fb0f1e7&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb0f1e7"]])

export default __exports__